import React, { useEffect, useState } from 'react'
import '../styles/WeekdayScheduler.css'
import { Row, Col, Popover, message, Button, Modal } from 'antd'
import {
    PlusCircleOutlined
} from '@ant-design/icons';
import WeekdaySchedulerItem from './WeekdaySchedulerItem';
import { PlusCircleFilled } from '@ant-design/icons'
import { connect } from 'react-redux';
import { requestServerPost, requestServerGet, selectPage } from '../actions';
import TimelineElementSchduleGeneratorPopup from './popups/TimelineElementSchduleGeneratorPopup';
import { useRef } from 'react';

function WeekdayScheduler(props) {

    const [schedules, setSchedules] = useState([]);
    const [showTimelineElementScheduleGenerator, setShowTimelineElementScheduleGenerator] = useState(false);
    const { data, onSaved = () => { } } = props;
    const { Timelineschedules } = data;

    const createTimelineElementSchedulePopupRef = useRef();
    var defaultData = {
        TimelineScheduleID: -1,
        TimelineID: -1,
        WeekDay: "0,1,2,3,4,5,6",
        StartTime: "",
        EndTime: "",
        StartDate: "",
        EndDate: ""
    }

    const createTimelineSchedule = (scheduledata) => {
        const { requestServerPost, usertoken } = props;


        const params = new FormData();
        const { TimelineScheduleID, TimelineID } = data;
        const { WeekDay, StartTime, EndTime, StartDate, EndDate } = scheduledata;

        // params.append("timelinescheduleid", TimelineScheduleID)
        params.append("timelineid", TimelineID)
        params.append("weekday", WeekDay)
        params.append("starttime", StartTime)
        params.append("endtime", EndTime)
        params.append("startdate", StartDate)
        params.append("enddate", EndDate)


        requestServerPost("create_timelineschedule", params, { }, (response) => {
            reloadTimelineSchedules();
        }, usertoken);
    }
    const deleteTimelineSchedule = (scheduledata) => {
        const { requestServerPost, usertoken } = props;
        const params = new FormData();
        const { TimelineScheduleID } = scheduledata;

        params.append("timelinescheduleid", TimelineScheduleID)

        requestServerPost("delete_timelineschedule", params, { }, (response) => {
            reloadTimelineSchedules();
        }, usertoken);
    }

    const reloadTimelineSchedules = () => {
        const { requestServerGet, usertoken } = props;

        const { TimelineID } = data;

        requestServerGet("get_timelineschedules", { timelineid: TimelineID }, {}, (response) => {
            setSchedules(response.data)
        }, usertoken);
    }

    useEffect(() => {
        setSchedules(Timelineschedules)
    }, [])

    useEffect(() => {
        // console.log(JSON.stringify(schedules))
    }, [schedules])

    const populateTimelineSchedules = () => {
        setShowTimelineElementScheduleGenerator(true)
    }

    return (
        <div className="scheduler">
            <div className="itemgroup">
                {/* <div style={{ marginBottom: "8px" }}>
                    <Button type="dashed" icon={<PlusCircleOutlined />} onClick={populateTimelineSchedules}>Populate Schedules</Button></div> */}
                <div>
                    {schedules.map((weekdaySchedule, index) => (
                        <WeekdaySchedulerItem key={`${weekdaySchedule.TimelineScheduleID}_${index}`} data={weekdaySchedule} onSaved={onSaved} onRemove={(e) => {
                            if (schedules.length > 1) {
                                deleteTimelineSchedule(weekdaySchedule)
                            }
                            else {
                                // deleteTimelineSchedule(weekdaySchedule)
                                message.warn("You must have at least one schedule item")
                                e.preventDefault();
                            }

                        }
                        }></WeekdaySchedulerItem>
                    ))}
                </div>
                <div onClick={(e) => {
                    // console.log("add schedules " + schedules.length)
                    const sch = [...schedules]

                    createTimelineSchedule(defaultData)
                    e.preventDefault();
                }} className="btn-plus-item">
                    <PlusCircleFilled style={{ color: "rgb(221, 221, 221)", cursor: "pointer", fontSize: "20px" }} />
                </div>
            </div>

            <Modal
                width={350}
                title={null}
                open={showTimelineElementScheduleGenerator}
                footer={null}
                // onOk={this.handleOk}
                // onCancel={this.handleCancel}
                destroyOnClose={true}
            >
                <TimelineElementSchduleGeneratorPopup key="create_timeline_element_schedule" ref={createTimelineElementSchedulePopupRef} onComplete={() => {
                    setShowTimelineElementScheduleGenerator(false)
                }}></TimelineElementSchduleGeneratorPopup>
            </Modal>
        </div>
    )
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage })(WeekdayScheduler);
